import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/states";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader label="Loading your workspace" fullscreen />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
